const ROLLBAR_SCRUB_FIELD_NAMES = [
  'authorization',
  'cookie',
  'set-cookie',
  'password',
  'passwd',
  'secret',
  'access_token',
  'refresh_token',
  'cf-turnstile-invisible-token',
  'cf-turnstile-managed-token',
  'x-g-recaptcha-response',
];

/** Rollbar SDK options: scrubFields redacts matching keys anywhere in the payload. */
// eslint-disable-next-line import/prefer-default-export
export function rollbarScrubOptions() {
  return {
    scrubFields: ROLLBAR_SCRUB_FIELD_NAMES,
  };
}
